<template>
    <div>
        <header id="header">
            <div class="inner">
                <div class="col col1">
                    <a class="btnNavi prev">
                        <span @click.stop.prevent="backBtn" class="ico">이전</span>
                    </a>
                </div>
                <div class="col col2">
                    <!-- 마이페이지, 주문내역 -->
                    <h1>영수증 이메일 발송</h1>
                </div>
                <!-- <div class='btnNavi home' @click="appMoveMain()">
                  <div class="ico">홈</div>
              </div> -->
            </div>
        </header>
        <div class="container">

            <p class="title">
            영수증을 받을 이메일 주소를 입력해 주세요.
            </p>
            <form @submit.prevent="submitEmail">
                <input v-model="email" type="email" placeholder="modnpay@seeroo.co.kr" required>
                <label for="save">
                    <input v-model="saveEmail" type="checkbox" id="save">
                    <span></span>
                    <span>입력한 이메일 주소 저장</span>
                </label>
                <input :disabled="isEmailSent" type="submit" value="보내기">
            </form>
        </div>
        <SingleBtnDialog
          v-if='showSingleBtnDialogFlag'
          :messageType='singleBtnMsgType'
          :onClickConfirmBtn='onClickConfirmBtn'/>

    </div>
</template>

<script>
import SendEmailMixins from '@/utils/SendEmailMixins'
import service from '@/backend/modnpay_app_api'
import SingleBtnDialog from '@/components/Dialog/SingleBtnDialog.vue'

export default {
  data () {
    return {
      channelType: '002', // 001: 모든오더, 002: 온누리오더
      isEmailSent: false // 이메일 전송 완료 시 버튼 disabled
    }
  },
  mixins: [SendEmailMixins],
  components: { SingleBtnDialog },
  methods: {
    backBtn () {
      this.$router.back()
    },
    async submitEmail () {
      // if (true) {
      if (!this.checkEmailData(this.email)) {
        this.showSingleBtnDialogFlag = true
        this.singleBtnMsgType = 24
        this.onClickConfirmBtn = () => { this.showSingleBtnDialogFlag = false }
        return
      }
      console.log(this.$store.getters.storeGroupCode)
      const req = {
        receiptEmail: this.email,
        isEmailSaved: this.saveEmail,
        channelType: this.channelType,
        storeGroupCode: this.$store.getters.storeGroupCode,
        orderSeq: this.$store.getters.orderSeq
      }
      const { data } = await service.sendEmail(req)
      const code = data.resultCode
      // const code = 0
      let msg = ''
      if (code === 0) {
        msg = '영수증이 입력하신 이메일로\n전송되었습니다.'
        // this.isEmailSent = true
        this.saveEmailInLocal()
      } else if (code === 19999) {
        msg = '이메일 전송에 실패했습니다.\n다시 시도해주세요.'
      }
      this.toastBottom(this, msg)
    },
    saveEmailInLocal () {
      // 비회원 일떄
      if (!this.isUser) {
        // 입력한 이메일 주소 저장
        if (this.saveEmail) {
          console.log('save local email')
          localStorage.setItem('userEmail', this.email)
          localStorage.setItem('saveEmail', this.saveEmail)
        } else {
          // 저장된 이메일 주소 제거
          console.log('unsave local email')
          localStorage.removeItem('userEmail')
          localStorage.removeItem('saveEmail')
        }
      }
    }
  }
}
</script>

<style scoped>
.lx-toast.lx-word-wrap {
  white-space: pre-line;
}

:root,
body {
    font-size: 10px !important;
    line-height: 1;
}
#header{
    height: 5.6rem;
}

@media (max-width: 359.8px) {

    :root,
    body {
        font-size: 8.75px !important;
    }
}
</style>

<style lang="scss" scoped>

.container {
    padding: 5.6rem 1.6rem 0rem 1.6rem;
    line-height: 1;

    .title{
        margin-top: 1.6rem;
        margin-bottom: 1.2rem;
        font-size: 1.4rem;
        font-weight: bold;
        color: #0d0d0d;
    }

    input {
        font-size: 16px;
        padding: 1rem 1.2rem;
        border: 1px solid #dddddd;
        width: 100%;
        &[type="submit"]{
            position: fixed;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            padding: 1.8rem 0;
            background-color: var(--primary);
            border: 0;
            color: white;
            font-size: 1.6rem;
        }
    }

    label{
    position: relative;
    font-weight: bold;
    font-size: 1.6rem;
    display: flex;
    gap: 0.8rem;
    align-items: center;
    margin-top: 0.8rem;
    }

    input[type="radio"],
    input[type="checkbox"]{
    position: absolute;
    left: -9999px;
    top: 1rem;
    z-index: 2;
    width: 1px;
    height: 1px;
    appearance: none;
    }

    input[type="checkbox"] + span {
    display: block;
    flex-shrink: 0;
    word-break: keep-all;
    width: 2.4rem;
    height: 2.4rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAABHNCSVQICAgIfAhkiAAAAOFJREFUeF7t3DEOwjAUBUHnTL7/DewzQRcJCbDEdmjSp9nMf2WutdZjeD4WuAT6rkOgw/W8BJpzOrYxxt777iDQGxICHe5EIIHalBJEEEGtAEGtnw0iiKBWgKDWzwYRRFArQFDrZ4MIIqgVIKj1s0EEEdQKENT62SCCCGoFCGr9bBBBBLUCBLV+NogggloBglo/G0QQQa0AQa2fDSKIoFaAoNbPBhFEUCtAUOtngwgiqBUgqPWzQQQR1AoQ1PrZIIIIagUIav1sEEEEtQIEtX426FdBrft/vu0fZofvKtAh0BNwm7owyRTPEAAAAABJRU5ErkJggg==) no-repeat;
    background-size: cover;
}

    input[type="checkbox"]:checked + span {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAABHNCSVQICAgIfAhkiAAAAphJREFUeF7t1kFLFGEcx/Hf044SSmpC0iGQSPQqRJdCUbr4BrRTb8AOgiBCxwhCPGgEEb6CzGvQSVzFU0QFXeoSdemQIRiUojOuzOqCys48M/N/npnH4bfXnZmd+ez3+c+j9ryFGviJFFAEiq+DQJrVQyACyQYsC2JBLEgmwIJkfpxBLIgFyQRYkMyPM4gFsSCZAAuS+XEGsSAWJBNgQTK/Us4gNdAN79V9+BNvUdvaFQmVDkgNXEXL2jjUtTYcft3GwegK8Cc7UqmATuM0spEilQaoGY4JpFIAqf6TZdXTFjlv/IfvELz+lnoeXXygW51orU5AXW+PfPiDR6s4XPqSGic84WIDWcYxDqS6L6O2vZfpn0p7kurrOn5bxZTjT1URvPyc9tJnjjdWkPd8BJfGbmJ/aBn4/V90U9qTcyincQ9GgEKcyuRg/Zq17zt2kXLEMbLETuM01K0h5YwjBmqGcwZp9A3w6592xSQ6oAAcq0D15fbzL/aHl+VIvR1o3XwQP5Cn1xG8+JTIOs1B4hkUV5ERpBCnOg5140r0JtASjrigxh1X5obgTd+OfIDMJRWMYwwovJBxJAdwjAIZRXIExziQESSHcKwAiZAcw7EGlAnJQRyrQKmQWiqFvsrj9kXifZBu01V5eg/e7J3oLcCPHUApqN6OyGOCmQ34ix91P2Xle+tASUqKezLf4iYwiWguQFmR/MebCOY/JHkOa8fkBpQWyQUc60O62d+q23GH57iCUwiQriSXcAoDikJyDadQoPNILuIUDlRHenIXateH/+y9tTeR5MK5vsUkN1rUuQTSyBOIQLLFyYJYEAuSCbAgmR9nEAtiQTIBFiTz4wxiQSxIJsCCZH6cQSyIBckEWJDMjzNI43cE1d7ZKFI6SqEAAAAASUVORK5CYII=) no-repeat;
    background-size: cover;
}

}

</style>
